import router from "../../router";
import axios from "axios";
import store from "../index";
import moment, { relativeTimeRounding } from "moment";
import i18 from "../../i18n";
//axios.defaults.baseURL = 'https://apistp.enterprisepanama.com/api/'
export default {
  namespaced: true,

  // estado
  state: {
    history_list: [],
    list_reserves: [], // reservas activas
    list_reserves_cancel: [], // reservas caducadas o anuladas
    sucursales: [], // objetos de sucursales para el primer flujo
    otraSucursal: false, // check si devolver a otra sucursal se selecciona
    sendReservation: {
      brand: 3, // marca del arrendatario
      sucursal_retiro: 5, // id sucursal retiro
      sucursal_devolucion: 5, // id sucursal devolución
      fecha_retiro: "", // fecha retiro
      hora_retiro: "10:00:00", // hora de retiro
      fecha_devolucion: "", // fecha de devolución
      hora_devolucion: "10:00:00", // hora de devolución
      edad: "25", // edad del arrendatario
    }, // datos enviados para realizar la reserva
    procesoReserva: false,
    auto: {}, // objeto con los detalles del auto que se ha seleccionado para la reserva
    calendario_sal: false, // estado del calendario en el flujo de reserva
    calendario_ent: false, // estado del calendario en el flujo de reserva
    precalculo: {}, // objeto para los autos con su precalculo en el segundo flujo
    loader: false, // estado de la carga
    calculo: {}, // objeto con los detalles del calculo segun auto
    addEdd: false, // estado del boton de Exoneración del Deducible, si está en false no ha sido seleccionado
    addCap: false, // estado del boton de Cobertura de Accidentes Personal, si está en false no ha sido seleccionado
    addClp: false,
    addRap: false,
    addMifi: false, // estado del boton de agregar mifi
    addSillabb: false, // estado del boton de agregar silla de bb
    addCondAdic: false, // true: conductores adicionales agregados, de lo contrario false
    montoExtras: 0,
    subTotal: 0,
    apo_fee: 0,
    itbms: 0,
    montoPaquete: 0,
    tarifa: 0,
    totalConductorAdicional: 0,
    porcentaje_sucursal: 0,

    reserveConfirm: {}, // objeto con los datos una vez realizada la reserva
    getReserve: {}, // objeto que se obtiene al momento de consultar por la reserva
    accionBuscar: false,
    modificar_reserva: false,
    accion_reservar: true,
    forma_pago: {}, // objeto que contiene la forma de pago
    confirmado: false, // estado del flujo de reserva al llegar al último paso
    motivos: {}, // objeto de los motivos por el cual anular una reserva
    detalleReserva: {},
    sendModify: {
      coberturas: [],
    }, // objeto enviado para modificar reserva
    accion_modificar: false, // accion del boton de modificar para identificar en que paso estamos
    errors: {}, // objeto para el manejo de errors
    idcar: "", // id del auto seleccionado desde la seccion de flota
    cdw_monto: 0, // Cobertura colisión y robo
    dat_monto: 0, // Cobertura daños a terceros
  },

  // mutaciones
  mutations: {
    add_history(state, payload) {
      state.history_list = payload;
    },
    //agregar reservas para hacer checkin al state
    add_reserves_to_list(state, payload) {
      state.list_reserves = payload.reservas_activas;
      state.list_reserves_cancel = payload.reservas_anuladas;
    },
    // abre o cierra el calendario de la reserva
    openCalendar1(state) {
      state.calendario_sal = true;
    },
    closeCalendar1(state) {
      state.calendario_sal = false;
    },
    // abre o cierra el calendario de la reserva
    openCalendar2(state) {
      state.calendario_ent = true;
    },
    closeCalendar2(state) {
      state.calendario_ent = false;
    },
    // recibe el valor inicial de la fecha de salida
    contextDate(state, date) {
      state.sendReservation.fecha_retiro = date.activeYMD;
    },

    // recibe el valor inicial de la fecha de entrega
    contextDate2(state, date) {
      state.sendReservation.fecha_devolucion = date.activeYMD;
    },

    // cuando la fecha de salida cambia, modifica el state
    updateFirstCalendar(state, date) {
      state.sendReservation.fecha_retiro = date;
      state.calendario_sal = !state.calendario_sal;
    },

    // cuando la fecha de entrega cambia, modifica el state
    updateSecondCalendar(state, date) {
      state.sendReservation.fecha_devolucion = date;
      state.calendario_ent = !state.calendario_ent;
    },

    mt_primerPaso(state, data) {
      state.sucursales = data;
    },

    // modifica el estado cuando se seleciona la sucursal de salida
    selecionSucursalSalida(state, data) {
      state.sendReservation.sucursal_retiro = data;

      if (state.otraSucursal === false) {
        state.sendReservation.sucursal_devolucion = data;
      }
    },

    // cambia el estado si se va a devolver en otra sucursal
    devolverOtraSucursal(state) {
      state.otraSucursal = !state.otraSucursal;

      // si el estado es false vuelve a su estado por defecto
      if (state.otraSucursal) {
        state.sendReservation.sucursal_devolucion =
          state.sendReservation.sucursal_retiro;
      } else {
        state.sendReservation.sucursal_devolucion =
          state.sendReservation.sucursal_retiro;
      }
    },

    // modifica el estado cuando se seleciona la sucursal de entrega
    selecionSucursalEntrega(state, id) {
      state.sendReservation.sucursal_devolucion = id;
    },

    // carga el objeto con el json del precalculo de los autos
    mt_precalculo(state, data) {
      state.precalculo = data.tarifas;
    },

    // loader
    mt_loader(state) {
      state.loader = !state.loader;
    },

    reservar(state) {
      state.modificar_reserva = false;
      state.accion_reservar = !state.accion_reservar;

      state.getReserve = {};
      state.accionBuscar = false;
    },

    modificar(state) {
      state.modificar_reserva = !state.modificar_reserva;
      state.accion_reservar = !state.accion_reservar;
    },

    // carga los dato necesarios segun el auto seleccionado
    vehiculoSeleccionado(state, data) {
      state.calculo = data.calculo; // respuesta del motor de calculo
      state.sendReservation.vehiculo_id = data.id_auto; // id del vehiculo
      state.auto = data.auto; // objeto del auto a mostrar
      state.sendReservation.tarifa = state.calculo.detalle.total; // total de la reserva
      state.sendReservation.dropoff = state.calculo.detalle.dropoff; // dropoff
      state.apo_fee = state.calculo.detalle.apo_fee; // apo_fee
      state.tarifa = state.calculo.detalle.tarifa;
      state.porcentaje_sucursal = data.porcentaje_sucursal.apo_fee; // porcentaje sucursal
      state.forma_pago = data.forma_pago; // forma de pago

      state.cdw_monto = state.calculo.detalle.cob_obligatoria.monto[0]; // Cobertura colisión y robo
      state.dat_monto = state.calculo.detalle.cob_obligatoria.monto[1]; // Cobertura daños a terceros

      // agregamos por defecto rap
      var rap = {
        sigla: state.calculo.detalle.coberturas.siglas[3],
        nombre: state.calculo.detalle.coberturas.nombre[3],
        monto: state.calculo.detalle.coberturas.monto[3],
      };

      store.commit("reserva/agregarCobertura", rap);
    },

    // cambio el estado cuando agrego la cobertura
    agregarCobertura(state, data) {
      state.montoExtras = state.montoExtras + parseFloat(data.monto);

      state.subTotal =
        state.dat_monto +
        state.cdw_monto +
        state.montoExtras +
        state.apo_fee +
        parseFloat(state.tarifa);

      console.log(state.sendReservation.tarifa);
      console.log(state.subTotal);
      state.itbms = state.subTotal * 0.07;
      state.sendReservation.tarifa = state.subTotal + state.itbms;

      if (data.sigla === "EDD") {
        state.addEdd = true;
      } else if (data.sigla === "CAP") {
        state.addCap = true;
      } else if (data.sigla === "CLP") {
        state.addClp = true;
      } else if (data.sigla === "RAP") {
        state.addRap = true;
      }

      state.sendReservation.coberturas.push(data);
    },

    // quitar cobertura
    quitarCobertura(state, data) {
      state.montoExtras = state.montoExtras - parseFloat(data.monto);

      state.subTotal =
        state.dat_monto +
        state.cdw_monto +
        state.montoExtras +
        state.apo_fee +
        parseFloat(state.tarifa);

      state.itbms = state.subTotal * 0.07;

      state.sendReservation.tarifa = state.subTotal + state.itbms;

      if (data.sigla === "EDD") {
        state.addEdd = false;
      } else if (data.sigla === "CAP") {
        state.addCap = false;
      } else if (data.sigla === "CLP") {
        state.addClp = false;
      } else if (data.sigla === "RAP") {
        state.addRap = false;
      }

      const pos = state.sendReservation.coberturas.find(
        (coberturas) => coberturas.nombre === data.nombre
      );

      const p = state.sendReservation.coberturas.indexOf(pos);

      state.sendReservation.coberturas.splice(p, 1);
    },

    agregarAccesorio(state, data) {
      state.montoExtras = state.montoExtras + parseFloat(data.monto);

      state.apo_fee = state.apo_fee + state.porcentaje_sucursal * data.monto;

      state.subTotal =
        state.dat_monto +
        state.cdw_monto +
        state.montoExtras +
        state.apo_fee +
        parseFloat(state.tarifa);

      state.itbms = state.subTotal * 0.07;

      state.sendReservation.tarifa = state.subTotal + state.itbms;

      if (data.sigla === "MW") {
        state.addMifi = true;
      } else if (data.sigla === "SB") {
        state.addSillabb = true;
      }
      state.sendReservation.accesorios.push(data);
    },

    quitarAccesorio(state, data) {
      state.montoExtras = state.montoExtras - parseFloat(data.monto);

      state.apo_fee =
        parseFloat(state.apo_fee).toFixed(2) -
        state.porcentaje_sucursal * data.monto;

      state.subTotal =
        state.dat_monto +
        state.cdw_monto +
        state.montoExtras +
        state.apo_fee +
        parseFloat(state.tarifa);

      state.itbms = state.subTotal * 0.07;

      state.sendReservation.tarifa = state.subTotal + state.itbms;

      if (data.sigla === "MW") {
        state.addMifi = false;
      } else if (data.sigla === "SB") {
        state.addSillabb = false;
      }

      const pos = state.sendReservation.accesorios.find(
        (accesorios) => accesorios.nombre === data.nombre
      );

      const p = state.sendReservation.accesorios.indexOf(pos);

      state.sendReservation.accesorios.splice(p, 1);
    },

    // conductor adicional
    agregarConductorAdicional(state, monto) {
      if (state.sendReservation.conductor_adicional < 5) {
        state.sendReservation.conductor_adicional++; // incremento de conductores

        state.addCondAdic = true;

        state.montoExtras = state.montoExtras + parseFloat(monto); // monto actual + monto de conductor adicional

        state.subTotal =
          state.montoExtras + state.apo_fee + parseFloat(state.tarifa);

        state.itbms = state.subTotal * 0.07;

        state.sendReservation.tarifa = state.subTotal + state.itbms;

        state.totalConductorAdicional = state.totalConductorAdicional + monto;
      }
    },

    // conductor adicional
    quitarConductorAdicional(state, monto) {
      if (state.sendReservation.conductor_adicional >= 1) {
        state.sendReservation.conductor_adicional--;

        state.montoExtras = state.montoExtras - parseFloat(monto); // monto actual + monto de conductor adicional

        state.subTotal =
          state.montoExtras + state.apo_fee + parseFloat(state.tarifa);

        state.itbms = state.subTotal * 0.07;

        state.sendReservation.tarifa = state.subTotal + state.itbms;

        state.totalConductorAdicional = state.totalConductorAdicional - monto;

        if (state.sendReservation.conductor_adicional === 0) {
          state.addCondAdic = false;
        }
      }
    },

    editReserve(state, reserva) {
      // si la consulta no existe
      if (reserva.error) {
        state.errors = reserva;
      } else {
        state.auto = reserva.auto;
        state.getReserve = reserva;
        state.modificar_reserva = !state.modificar_reserva;
        state.accionBuscar = true;
        state.errors = {};
      }
    },

    ReservaRealizada(state, data) {
      state.reserveConfirm = data.reserva;
      state.calculo = data.detalle_calculo;
    },
    changeStateReserve(state) {
      state.procesoReserva = !state.procesoReserva;
    },
    confirmado(state) {
      state.confirmado = !state.confirmado;
    },
    motivosCancelar(state, data) {
      state.motivos = data;
    },
    mt_verDetalle(state, data) {
      state.detalleReserva = data;
    },
    mt_reservaModificar(state, data) {
      state.calculo = data.calculo; // respuesta del motor de calculo
      state.sendReservation.tarifa = data.calculo.detalle.total; // total de la reserva
      state.sendReservation.dropoff = data.calculo.detalle.dropoff; // dropoff
      state.apo_fee = data.calculo.detalle.apo_fee; // apo_fee
      state.tarifa = data.calculo.detalle.tarifa;
      state.porcentaje_sucursal = data.porcentaje_sucursal.apo_fee; // porcentaje sucursal

      state.auto = data.reserva.auto;

      // convercion de fecha y hora
      let retiro = moment(data.reserva.fecha_salida).format("YYYY-MM-DD");
      let entrega = moment(data.reserva.fecha_entrada).format("YYYY-MM-DD");
      let hora_retiro = moment(data.reserva.fecha_retiro).format("h:mm:ss");
      let hora_entrada = moment(data.reserva.fecha_entrada).format("h:mm:ss");

      // datos de la reserva

      state.sendReservation.id = data.reserva.id;
      state.sendReservation.sucursal_retiro = data.reserva.sucursal_retiro;
      state.sendReservation.sucursal_devolucion =
        data.reserva.sucursal_devolucion;
      state.sendReservation.fecha_retiro = retiro;
      state.sendReservation.fecha_devolucion = entrega;
      state.sendReservation.hora_retiro = hora_retiro;
      state.sendReservation.hora_devolucion = hora_entrada;
      state.sendReservation.edad = "25";
      state.sendReservation.vehiculo_id = data.reserva.vehiculo_id;
      state.sendReservation.idp = data.reserva.cedula;
      state.sendReservation.nombres = data.reserva.nombres;
      state.sendReservation.apellido_paterno = data.reserva.apellido_paterno;
      state.sendReservation.apellido_materno = data.reserva.apellido_materno;
      state.sendReservation.email = data.reserva.email;
      state.sendReservation.pais = data.reserva.pais;
      state.sendReservation.celular = data.reserva.celular;
      state.sendReservation.observaciones = data.reserva.observaciones;
      state.sendReservation.linea_aerea = data.reserva.linea_aerea;
      state.sendReservation.num_vuelo = data.reserva.vuelo;
      state.sendReservation.coberturas = [];
      state.sendReservation.accesorios = [];

      // datos de la reserva

      state.accion_modificar = true;

      var str = data.reserva.coberturas;
      var coberturas = str.split(",");

      var str = data.reserva.accesorios_id;
      var accesorios = str.split(",");

      if (
        (coberturas[0] === "EDD") |
        (coberturas[1] === "EDD") |
        (coberturas[2] === "EDD") |
        (coberturas[3] === "EDD")
      ) {
        var edd = {
          sigla: state.calculo.detalle.coberturas.siglas[0],
          nombre: state.calculo.detalle.coberturas.nombre[0],
          monto: state.calculo.detalle.coberturas.monto[0],
        };

        store.commit("reserva/agregarCobertura", edd);
      }

      if (
        (coberturas[0] === "CAP") |
        (coberturas[1] === "CAP") |
        (coberturas[2] === "CAP") |
        (coberturas[3] === "CAP")
      ) {
        var cap = {
          sigla: state.calculo.detalle.coberturas.siglas[1],
          nombre: state.calculo.detalle.coberturas.nombre[1],
          monto: state.calculo.detalle.coberturas.monto[1],
        };

        store.commit("reserva/agregarCobertura", cap);
      }

      if (
        (coberturas[0] === "CLP") |
        (coberturas[1] === "CLP") |
        (coberturas[2] === "CLP") |
        (coberturas[3] === "CLP")
      ) {
        var clp = {
          sigla: state.calculo.detalle.coberturas.siglas[2],
          nombre: state.calculo.detalle.coberturas.nombre[2],
          monto: state.calculo.detalle.coberturas.monto[2],
        };

        store.commit("reserva/agregarCobertura", clp);
      }

      if (
        (coberturas[0] === "RAP") |
        (coberturas[1] === "RAP") |
        (coberturas[2] === "RAP") |
        (coberturas[3] === "RAP")
      ) {
        var rap = {
          sigla: state.calculo.detalle.coberturas.siglas[3],
          nombre: state.calculo.detalle.coberturas.nombre[3],
          monto: state.calculo.detalle.coberturas.monto[3],
        };

        store.commit("reserva/agregarCobertura", rap);
      }

      if ((accesorios[0] === "MW") | (accesorios[1] === "MW")) {
        var mw = {
          sigla: state.calculo.detalle.accesorios.siglas[0],
          nombre: state.calculo.detalle.accesorios.nombre[0],
          monto: state.calculo.detalle.accesorios.monto[0],
        };

        store.commit("reserva/agregarAccesorio", mw);
      }

      if ((accesorios[0] === "SB") | (accesorios[1] === "SB")) {
        var sb = {
          sigla: state.calculo.detalle.accesorios.siglas[1],
          nombre: state.calculo.detalle.accesorios.nombre[1],
          monto: state.calculo.detalle.accesorios.monto[1],
        };

        store.commit("reserva/agregarAccesorio", sb);
      }

      for (let index = 0; index < data.reserva.conductor_adicional; index++) {
        let monto = data.calculo.detalle.conductor_adicional;
        store.commit("reserva/agregarConductorAdicional", monto);
      }
    },
    // toma el id del vehiculo para hacer reserva desde la flota
    mt_selectFromFleet(state, id) {
      state.idcar = id;
    },
    resetValues(state) {
      // mutacion para resetear lo valores predeterminados
      state.sendReservation = {
        sucursal_retiro: 5,
        sucursal_devolucion: state.sendReservation.sucursal_retiro,
        fecha_retiro: "",
        fecha_devolucion: "",
        hora_retiro: "10:00:00",
        hora_devolucion: "10:00:00",
        edad: "25",
        vehiculo_id: "",
        idp: "",
        nombres: "",
        apellido_paterno: "",
        apellido_materno: "",
        email: "",
        pais: "",
        prefijo: "",
        tel: "",
        forma_pago: 7,
        licencia: "",
        celular: "",
        observaciones: "",
        linea_aerea: "",
        num_vuelo: "",
        tarifa: 0,
        conductor_adicional: 0,
        coberturas: [],
        accesorios: [],
        brand: 3, // envio de la marca para identificacion al momento de almacenar reserva
      };

      state.precalculo = {};

      state.addEdd = false;
      state.addCap = false;
      state.addClp = false;
      state.addRap = false;
      state.addMifi = false;
      state.addSillabb = false;

      (state.montoExtras = 0),
        (state.subTotal = 0),
        (state.apo_fee = 0),
        (state.itbms = 0),
        (state.tarifa = 0),
        (state.porcentaje_sucursal = 0);

      state.procesoReserva = false;
      state.confirmado = false;

      state.calculo = {};

      state.accion_reservar = true;
      state.accionBuscar = false;
      state.modificar_reserva = false;

      state.detalleReserva = {};
      state.getReserve = {};

      state.errors = {};
      state.loader = false;

      state.accionBuscar = false;
      state.accion_modificar = false;
    },
  },

  // acciones
  actions: {
    //checkin
    check_in({ commit, dispatch }, payload) {
      axios
        .post("checkin", payload, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function(response) {
          //reload()
          dispatch("get_reserves");
        })
        .catch(function(error) {});
    },

    historial({ commit }) {
      axios
        .get("mostrar-historial/" + this.state.autenticacion.user.id)
        .then(function(resp) {
          // handle success
          commit("add_history", resp.data);
        })
        .catch(function(error) {
          // handle error
        });
    },

    down_contract({ commit }, payload) {
      axios
        .get(
          "mostrar-contrato/" + payload + "/" + this.state.autenticacion.user.id
        )
        .then(function(resp) {
          //var pdfResult = response.data.base64;

          let pdfWindow = window.open("");
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
              encodeURI(resp.data) +
              "'></iframe>"
          );
          //window.open("data:application/pdf;base64," + resp.data);
          // handle success
          //commit('add_history', resp.data)
        })
        .catch(function(error) {
          // handle error
        });
    },

    down_invoice({ commit }, payload) {
      axios
        .get(
          "mostrar-factura/" + payload + "/" + this.state.autenticacion.user.id
        )
        .then(function(resp) {
          window.open(resp.data);
          // handle success
          //commit('add_history', resp.data)
        })
        .catch(function(error) {
          // handle error
        });
    },

    primerPaso({ commit }) {
      axios
        .get("paso-uno/3")
        .then((resp) => {
          commit("mt_primerPaso", resp.data);
        })
        .catch(() => {
          //console.clear()
        });
    },

    // pre calculo luego de accion continuar
    preCalculo({ commit, state }) {
      commit("changeStateReserve");
      //
      commit("mt_loader");

      router.push({ name: "Reservestep3" });

      // datos necesarios para el precalculo
      let datos = {
        brand: 3,
        fecha_retiro: state.sendReservation.fecha_retiro,
        fecha_devolucion: state.sendReservation.fecha_devolucion,
        hora_retiro: state.sendReservation.hora_retiro,
        hora_devolucion: state.sendReservation.hora_devolucion,
        sucursal_retiro: state.sendReservation.sucursal_retiro,
        sucursal_devolucion: state.sendReservation.sucursal_devolucion,
      };

      axios.post("paso-dos", datos).then((resp) => {
        console.log(resp.data);
        commit("mt_precalculo", resp.data);
        //
        commit("mt_loader");
      });
    },

    // seleccion del vehiculo para continuar al paso 3
    seleccionarVehiculo({ commit, state }, id) {
      commit("mt_loader");
      axios
        .post("paso-tres", {
          fecha_retiro: state.sendReservation.fecha_retiro,
          fecha_devolucion: state.sendReservation.fecha_devolucion,
          hora_retito: state.sendReservation.hora_retiro,
          hora_devolucion: state.sendReservation.hora_devolucion,
          sucursal_retiro: state.sendReservation.sucursal_retiro,
          sucursal_devolucion: state.sendReservation.sucursal_devolucion,
          vehiculo_id: id,
          brand: 3,
        })
        .then((resp) => {
          commit("vehiculoSeleccionado", resp.data);
          router.push({ name: "Reservestep4" });
          commit("mt_loader");
        });
    },

    // almacenar reserva
    reservar({ commit, state }, datos) {
      if (
        datos.coberturas_obligadorias.monto[0] != 0 &&
        datos.coberturas_obligadorias.monto[1] != 0
      ) {
        state.sendReservation.coberturas_obligatorias =
          datos.coberturas_obligadorias.siglas;
      } else {
        state.sendReservation.coberturas_obligatorias = "";
      }

      let path;
      if (datos.isAuth) {
        path = "paso-cuatro-auth";
      } else {
        path = "paso-cuatro";
      }
      //TODO: cambiar ruta de almacenamiento si está autenticado.
      commit("mt_loader");
      state.sendReservation.subtotal = state.subTotal;
      state.sendReservation.apo_fee = state.apo_fee;
      state.sendReservation.itbms = state.itbms;
      state.sendReservation.tyk = state.calculo.detalle.tarifa;
      state.sendReservation.totalConductorAdicional =
      state.totalConductorAdicional;
      state.sendReservation.idioma = i18.locale;

      axios
        .post(path, state.sendReservation)
        .then((resp) => {
          commit("ReservaRealizada", resp.data);
          commit("confirmado");
          commit("changeStateReserve");

          router.push({ name: "reserveFinalStep" });

          commit("mt_loader");
        })
        .catch((e) => {
          //console.log(e)
        });
    },

    // buscar reserva a modificar
    buscarReservaModificar({ commit }, data) {
      commit("mt_loader");
      axios
        .get(
          "buscar-reserva/" +
            data.num_reserva +
            "/" +
            data.apellido_paterno +
            "/" +
            data.brand
        )
        .then((resp) => {
          commit("editReserve", resp.data);
          commit("mt_loader");
        })
        .catch((error) => {});
    },

    // motivos cancelar reserva
    motivosCancelarReserva({ commit }) {
      axios.get("motivos-anular").then((resp) => {
        commit("motivosCancelar", resp.data);
      });
    },

    // cancelar reserva
    async cancelarReserva({ commit }, payload) {
      await commit("mt_loader");
      const resp = await axios.post("anular-reserva/3", payload);
      await commit("mt_loader");

      return resp.data;
    },

    detallesReserva({ commit, state }, data) {
      commit("mt_loader");
      axios.post("detalle-reserva", data).then((resp) => {
        commit("mt_verDetalle", resp.data);

        router.push({ name: "details" });

        commit("mt_loader");
      });
    },

    // busca la reserva y hace el calculo de dicha reserva
    modificarReserva({ commit, state }, payload) {
      // si salimos desde el proceso de reserva
      state.confirmado = false;
      commit("mt_loader");

      axios.post("modificar-reserva", payload).then((resp) => {
        //commit('resetValues')
        commit("mt_reservaModificar", resp.data);
        router.push({ name: "modificarReserva" });
        commit("mt_loader");
      });
    },

    // actualizar reserva
    actualizarReserva({ commit, state }) {
      state.sendReservation.subtotal = state.subTotal;
      state.sendReservation.apo_fee = state.apo_fee;
      state.sendReservation.itbms = state.itbms;
      state.sendReservation.tyk = state.calculo.detalle.tarifa;
      state.sendReservation.totalConductorAdicional =
        state.totalConductorAdicional;

      axios.put("actualizar-reserva", state.sendReservation);
    },

    // precalcular desde el formulario de moficar
    // modificarReservaFormulario({commit}, payload)
    // {
    //     axios.post('recalcular', payload).then(resp=>{

    //         commit('mt_reservaModificar', resp.data)
    //         router.push({name: 'modificar-reserva'})
    //     })
    // },

    // logica de precalculo, selecciona el vehiculo desde flota
    seleccionVehiculoFleet({ commit, state }) {
      axios
        .post("paso-tres", {
          fecha_retiro: state.sendReservation.fecha_retiro,
          fecha_devolucion: state.sendReservation.fecha_devolucion,
          hora_retito: state.sendReservation.hora_retiro,
          hora_devolucion: state.sendReservation.hora_devolucion,
          sucursal_retiro: state.sendReservation.sucursal_retiro,
          sucursal_devolucion: state.sendReservation.sucursal_devolucion,
          vehiculo_id: state.idcar,
          brand: 3,
        })
        .then((resp) => {
          state.procesoReserva = true;
          commit("vehiculoSeleccionado", resp.data);
          router.push({ name: "Reservestep4" });
        });
    },

    get_reserves({ commit }) {
      axios
        .post("reservas")
        .then((resp) => {
          commit("add_reserves_to_list", resp.data);
        })
        .catch((e) => {
          if (e.response.status == 401) {
            router.push({ name: "Home" });
          }
        });
    },
  },

  //getters
  getters: {
    history(state) {
      let hlist = state.history_list;
      return hlist;
    },
  },
};
